<template>
  <div v-if="loading" class="flex items-center justify-center h-full">
    <loading-spinner diameter="64px" />
  </div>

  <alert-badge
    v-else-if="error.title"
    isDanger
    :title="error.title"
    :body="error.body"
    @dismissed="
      () => {
        error.title = '';
        error.body = '';
      }
    "
  />

  <div v-else>
    <div class="flex flex-row">
      <div class="flex flex-col">
        <action-button :title="t('print')" faIcon="print" @click="print" />
        <action-button
          :title="$t('views.sales.newSale')"
          isSuccess
          @click="$router.push($Route.SALES_NEW_SALE)"
        >
          <custom-icon>
            <i-new-sale />
          </custom-icon>
        </action-button>
      </div>

      <SaleReceiptA4
        v-if="$ctx.getReceiptSize() == 'a4' || $ctx.getReceiptSize() == 'a5'"
        :order="order"
        :transactions="transactions"
        :barcodeText="barcodeText"
      ></SaleReceiptA4>

      <SaleReceiptSmall
        v-if="$ctx.getReceiptSize() == 'receipt'"
        :order="order"
        :transactions="transactions"
        :barcodeText="barcodeText"
      ></SaleReceiptSmall>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { i18nOrderMessages, Order } from "@/models/sales/Order";
import { useI18n } from "vue-i18n";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import AlertBadge from "@/components/AlertBadge.vue";
import { Transaction } from "@/models/accounting/Transaction";
import ActionButton from "@/components/ActionButton.vue";
import INewSale from "@/components/icons/sales/INewSale.vue";
import CustomIcon from "@/components/CustomIcon.vue";
import SaleReceiptA4 from "./SaleReceiptA4.vue";
import SaleReceiptSmall from "./SaleReceiptSmall.vue";

export default defineComponent({
  components: {
    SaleReceiptA4,
    SaleReceiptSmall,
    LoadingSpinner,
    AlertBadge,
    ActionButton,
    CustomIcon,
    INewSale
  },

  setup() {
    const { t } = useI18n({
      messages: {
        en: {
          ...i18nOrderMessages.en,
          print: "Print Receipt"
        },
        ar: {
          ...i18nOrderMessages.ar,
          print: "اطبع الفاتورة"
        }
      }
    });

    return { t };
  },
  data() {
    return {
      order: new Order(),
      transactions: [] as Array<Transaction>,
      loading: true,
      barcodeText: "",
      error: {
        title: "",
        body: ""
      }
    };
  },
  async mounted() {
    try {
      const orderRes = await this.$http.get<Order>(
        `${Order.ENDPOINT}/${this.$route.params.id}`
      );
      this.order = Order.from(orderRes);
      this.transactions = this.order.invoice.transactions.filter(
        t => t.isReceipt
      );
    } catch (error) {
      this.error.title = error.title;
      this.error.body = error.body;
    } finally {
      this.loading = false;
      this.barcodeText = `${this.order.externalID!.slice(
        0,
        5
      )}-${this.order.externalID!.slice(5)}`;
    }
  },
  methods: {
    print() {
      window.print();
    }
  }
});
</script>
<style></style>
